var exports = {
  "q": "LeagueBadge.module__badge___anRLak",
  "K": "LeagueBadge.module__icon___anRLak",
};

module.exports = exports;
